import React, { useEffect, useState } from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar'
import axios from 'axios'
import { SERVER_URL } from '../Config'

function Users() {
  const [Users, setUsers] = useState([])
  const [searchTerm, setSearchTerm] = useState("");

  const users = async () => {
    try {
      await axios.get(`${SERVER_URL}/api/admin/usersList`).then((res) => {
        if (res.data.status == true) {
          setUsers(res.data.users)
        } else {
          setUsers([])
        }
      })
    } catch (err) {
      console.log(err)
      setUsers([])
    }
  }
  useEffect(() => {
    users()
  }, [])

  const filteredUsers = Users.filter((user) =>
    Object.values(user)
      .concat(user.wallets.map((wallet) => wallet.wallet_address)) // Include wallet addresses in search
      .some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
  );


  function formatDate(dateString) {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  return (
    <div>
      <>
        <Header />
        <Sidebar />
        <div className="page-wrapper bg-wrapper">
          <div className="content">
            <div className="buy-form">
              <div className="row">
                <div className="col-sm-4 col-3">
                  <h4 className="page-title">Users List</h4>
                </div>
                {/* <div className="col-sm-8 col-9 text-end m-b-20">
            <a
              href="add-employee.html"
              className="btn btn-primary float-right btn-rounded"
            >
              <i className="fas fa-plus" /> Add Employee
            </a>
          </div> */}
              </div>
              <div className="row filter-row">
                <div className="col-sm-6 col-md-3">
                    <input
                      type="text"
                      placeholder="Search users..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="form-control mb-3"
                    />
                </div>

              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table table-striped custom-table">
                      <thead>
                        <tr>
                          <th style={{ minWidth: 200 }}>Name</th>
                          <th>User ID</th>
                          <th>App Id</th>
                          <th style={{ minWidth: 110 }}>Join Date</th>
                          <th style={{ minWidth: 110 }}>EVM Wallet</th>
                          <th style={{ minWidth: 110 }}>TRON Wallet</th>
                          <th style={{ minWidth: 110 }}>SOL Wallet</th>
                          <th>Status</th>
                          <th className="text-end">Block Status</th>
                        </tr>
                      </thead>
                      <tbody>

                        {/* <tr>
                    <td>
                      <img
                        width={28}
                        height={28}
                        src="/assets/img/user.jpg"
                        className="rounded-circle"
                        alt=""
                      />{" "}
                      <h2>Albina Simonis</h2>
                    </td>
                    <td>SF-0001</td>
                    <td>
                      <a
                        href="../../../cdn-cgi/l/email-protection"
                        className="__cf_email__"
                        data-cfemail="cdaca1afa4a3acbea4a0a2a3a4be8da8b5aca0bda1a8e3aea2a0"
                      >
                        [email&nbsp;protected]
                      </a>
                    </td>
                    <td>828-634-2744</td>
                    <td>7 May 2015</td>
                    <td>
                      <span className="custom-badge status-green">Staff</span>
                    </td>
                    <td className="text-end">
                      <div className="dropdown dropdown-action">
                        <a
                          href="employees.html#"
                          className="action-icon dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fas fa-ellipsis-v" />
                        </a>
                        <div className="dropdown-menu dropdown-menu-right">
                          <a
                            className="dropdown-item"
                            href="edit-employee.html"
                          >
                            <i className="fas fa-pencil-alt m-r-5" /> Edit
                          </a>
                          <a
                            className="dropdown-item"
                            href="employees.html#"
                            data-bs-toggle="modal"
                            data-bs-target="#delete_employee"
                          >
                            <i className="fas fa-trash-alt m-r-5" /> Delete
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr> */}
                        {filteredUsers.length > 0 ? (
                          filteredUsers.map((data, index) => (
                            <tr key={index + 1}>
                              <td>{index + 1}</td>
                              <td>
                               User {data.user_id}
                              </td>
                              <td>{data.app_id}</td>
                              <td>{formatDate(data.created_at)}</td>
                              <td>{data.wallets[0].wallet_address.substring(0, 12)}...</td>
                              <td>{data.wallets[1].wallet_address.substring(0, 12)}...</td>
                              <td>{data.wallets[2].wallet_address.substring(0, 12)}...</td>
                              <td ><span className="custom-badge status-green">Active</span></td>
                              <td ><span className="custom-badge status-green">UnBlocked</span></td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">No data found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="notification-box">
            <div className="msg-sidebar notifications msg-noti">
              <div className="topnav-dropdown-header">
                <span>Messages</span>
              </div>
              <div className="drop-scroll msg-list-scroll" id="msg_list">
                <ul className="list-box">
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Richard Miles </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item new-message">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">John Doe</span>
                          <span className="message-time">1 Aug</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Tarah Shropshire </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Mike Litorus</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Catherine Manseau </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">D</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Domenic Houston </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">B</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Buster Wigton </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Rolland Webber </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Claire Mapes </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Melita Faucher</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Jeffery Lalor</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">L</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Loren Gatlin</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="chat.html">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Tarah Shropshire</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <a href="chat.html">See all messages</a>
              </div>
            </div>
          </div>
        </div>
        <div id="delete_employee" className="modal fade delete-modal" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body text-center">
                <img src="/assets/img/sent.png" alt="" width={50} height={46} />
                <h3>Are you sure want to delete this Employee?</h3>
                <div className="m-t-20">
                  {" "}
                  <a
                    href="employees.html#"
                    className="btn btn-white"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </a>
                  <button type="submit" className="btn btn-danger">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

    </div>
  )
}

export default Users
